export const client_secret = "SZ05kXOYQIK85hEkSar0bUSM0IxtBfqrzwOnsjsO";
export const client_id = "2";
export const grant_type = "password";
